export const UPLOAD_FOLDER = {
  PERSONAL_PARTICULAR: 'personal-particular',
  SIGNATURE: 'signature',
  RESALE: 'resale',
};
